<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="AgentZoneForm">
      <el-row>
        <el-col :span="3">
          <el-form-item label="No" prop="catNm">
            <el-input v-model="form.scheduleId" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item label="AS기사">
            <el-select v-model="form.userId">
              <el-option value='' label="선택">선택</el-option>
              <el-option
                  v-for="item in combos['agerntUser']"
                  :key="item.key"
                  :value="parseInt(item.key)"
                  :label="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="근무일자" prop="catNm">
            <el-date-picker type="date" placeholder="Pick a date" v-model="form.scheduleDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item label="오전/오후">
            <el-select v-model="form.dayType">
              <el-option value='' label="선택">선택</el-option>
              <el-option
                  v-for="item in combos['dayType']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item label="미근무 사유">
            <el-select v-model="form.scheduleCd">
              <el-option value='' label="선택">선택</el-option>
              <el-option
                  v-for="item in combos['scheduleCd']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="미근무 상세 사유" prop="catNm">
            <el-input v-model="form.description"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

export default {
  name: "ScheduleManagerInfo",
  props: ['custParam', 'parentNm'],
  data() {
    return {
      form: {
        asAgentId: "",
        asAgentNm: "",
        companyId: "",
        createDt: "",
        creatorId: "",
        creatorNm: "",
        dayType: "",
        deleteYn: "",
        description: "",
        no: "",
        scheduleCd: "",
        scheduleDt: this.$moment().format('YYYY-MM-DD'),
        scheduleId: "",
        updateDt: "",
        updatorId: "",
        updatorNm: "",
        userId: "",
        userNm: "",
      },
      combos: {
        'dayType' : [], // 오전 / 오후
        'scheduleCd' : [],  // 미근무 사유
        'agerntUser' : [],        //AS기사
      },
      // eslint-disable-next-line vue/no-dupe-keys
      parentNm: "",
    };
  },
  methods: {
    scheduleManagerInfo() {
      Object.assign(this.form, this.custParam);
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/scheduleMng/init`)
          .then(response => {
            this.combos['agerntUser'] = response.data.agerntUser;  //AS기사
            this.combos['dayType'] = response.data.dayType;        // 오전 / 오후
            this.combos['scheduleCd'] = response.data.scheduleCd;  // 미근무 사유
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
      this.createColumnDefs();
    },
  },
  beforeMount() {
    this.init();
  },
  watch: {
    custParam() {
      this.scheduleManagerInfo();
    },
    'form.areaAgent'() {
      this.init();
    },
    'form.areaAgentDetail'() {
      this.init();
    },
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}

</style>